const getProductPrice = (num, price) => 
    (Math.round(num * price * 100) / 100).toFixed(2);

export default getProductPrice
